export default theme => ({
  resizable: {
    cursor: "pointer",
    backgroundColor: theme.palette.userSecondary.main,
    color: theme.palette.white.main,
    fontWeight: "bold",
    textTransform: "uppercase",
    justifyContent: "center",
    alignContent: "center",
    textAlign: "center",
    border: "1px solid",
    borderColor: theme.palette.shadow.main,
    position: "absolute",
  },
  resizable__disabled: {
    cursor: "default",
    border: "1px solid",
    backgroundColor: theme.palette.userSecondary.light,
    color: theme.palette.shadow.main,
  },
  content__wrapper: {
    height: 50,
  },
  content__text: {
    display: "flex !important",
    flexDirection: "column",
    height: "100%",
    minHeight: 50,
    justifyContent: "center",
    alignContent: "center",
    textAlign: "center",
  },
});
